<template>
  <div role="banner">
    <the-hero></the-hero>
    <search-c-t-a></search-c-t-a>
    <the-home-page-listings></the-home-page-listings>
    <the-home-page-about></the-home-page-about>
    <the-home-page-testimonials></the-home-page-testimonials>
    <h2 class="display-1 mt-5 text-xs-center grey--text text--darken-2">
      Quick Search Links
    </h2>
    <search-links></search-links>
  </div>
</template>

<script>
import TheHero from '../components/TheHero';
import SearchCTA from '../components/SearchCTA';
import SearchLinks from '../components/SearchLinks';
import TheHomePageListings from '../components/TheHomePageListings';
import TheHomePageAbout from '../components/TheHomePageAbout';
import TheHomePageTestimonials from '../components/TheHomePageTestimonials';

export default {
  components: {
    TheHomePageListings,
    TheHomePageAbout,
    TheHomePageTestimonials,
    TheHero,
    SearchLinks,
    SearchCTA,
  },
  metaInfo: {
    title: 'Henderson and Las Vegas Homes',
  },
};
</script>
